import { GeoshapeAdapter } from '@leverege/ui-google-maps-elements';
import Model from "../../shared/renderers/UserPositionModel.js";
import Util from "./Util.js";
import Symbolizers from "../../shared/Symbolizers.js";
const SYMBOL_TYPE = 'userPosition';
export default class UserPositionAdapter extends GeoshapeAdapter {
  getShapeData(item, id, options) {
    const {
      model,
      symbols
    } = options;
    const app = {
      visible: true,
      name: model.name
    };
    const geoJson = {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Point',
        coordinates: [item.longitude, item.latitude]
      }
    };
    const subtype = Symbolizers.getSymbol(model.symbolizer, item, null);
    app.isRollover = false;
    app.isSelected = false;
    app.showSymbol = true;
    app.showLabel = false;
    app.symbol = Array.isArray(subtype) ? symbols.getTypeSymbol(subtype[0] || SYMBOL_TYPE, subtype[1], app.isRollover, app.isSelected) : symbols.getTypeSymbol(SYMBOL_TYPE, subtype, app.isRollover, app.isSelected);
    return {
      dataType: 'userPosition',
      geoJson,
      appearance: app
    };
  }
  getSymbolLayerOptions(style, layerGroup, options) {
    const {
      model,
      zoom
    } = options;
    const nScale = model && Model.getScale(model) || 1;
    const show = model && Model.getShowAtZoom(model);
    const hide = model && Model.getHideAtZoom(model);
    const visible = Util.getVisible(show, hide, zoom);
    return {
      visible,
      pickable: false,
      getIcon: d => {
        const symbol = d.properties.symbol;
        return {
          url: symbol.src,
          width: symbol.width,
          height: symbol.height || symbol.width
        };
      },
      getIconSize: d => {
        const symbol = d.properties.symbol;
        const size = 0.5 * nScale;
        return symbol.width * size;
      }
    };
  }
}